module.exports = __webpack_public_path__ + "assets/img/mall-banner-01.382714e5.png";